import React, { useState } from "react";
import { Typography } from "@mui/material";
import successTick from "../../assets/successTick.svg";
import "./pdfsuccess.scss";
import CommonModal from "./CommonModal";
import { pageLocale } from "../../utils/locale";

const PdfSuccess = ({ successPopup, setSuccessPopup }) => {
  const { sent_successfully, sent_successfully_desc } = pageLocale("rompdf");
  const [loaded, setLoaded] = useState(false);
  const load = () => {
    setLoaded(true);
  };
  return (
    <CommonModal
      open={successPopup}
      onClose={() => setSuccessPopup(false)}
      className="pdf-success"
    >
      <div className="pdf-success-main-wrapper">
        <div className="success-main-box">
          <img
            src={successTick}
            className="success-tick"
            alt="success-tick"
            onLoad={load}
          />
          {loaded && (
            <Typography className="success-message">
              {sent_successfully}
            </Typography>
          )}
        </div>
        {loaded && (
          <Typography className="success-info-text">
            {sent_successfully_desc}
          </Typography>
        )}
      </div>
    </CommonModal>
  );
};

export default PdfSuccess;
